import classNames from 'classnames'
import * as React from 'react'
import { DefaultContent } from 'react-content-engine'

import './CalendarMonth.scss'

interface EasterEggCalendarMonthProps {
  onComplete?: () => void
}
interface EasterEggCell {
  selected: boolean
  disabled: boolean
}

interface EasterEggCalendarMonthState {
  cells: EasterEggCell[]
}
class EasterEggCalendarMonth extends React.Component<
  EasterEggCalendarMonthProps,
  EasterEggCalendarMonthState
> {
  constructor(props: EasterEggCalendarMonthProps) {
    super(props)
    const initalCell: EasterEggCell = {
      selected: false,
      disabled: true,
    }
    const enabled = [0, 1, 2, 3, 4, 8, 10, 15, 17, 22, 24, 29, 30, 31]
    this.state = {
      cells: Array(35)
        .fill(initalCell)
        .map((x, index) =>
          enabled.includes(index) ? { ...x, disabled: false } : x,
        ),
    }
  }

  public render() {
    return (
      <div className="calendar-month">
        <table>
          <thead>
            <tr>
              <th>
                <DefaultContent contentKey="monday-short">MON</DefaultContent>
              </th>
              <th>
                <DefaultContent contentKey="tuesday-short">TUE</DefaultContent>
              </th>
              <th>
                <DefaultContent contentKey="wednesday-short">
                  WED
                </DefaultContent>
              </th>
              <th>
                <DefaultContent contentKey="thursday-short">THU</DefaultContent>
              </th>
              <th>
                <DefaultContent contentKey="friday-short">FRI</DefaultContent>
              </th>
              <th>
                <DefaultContent contentKey="saturday-short">SAT</DefaultContent>
              </th>
              <th>
                <DefaultContent contentKey="sunday-short">SUN</DefaultContent>
              </th>
            </tr>
          </thead>
          <tbody>{this.renderWeeks()}</tbody>
        </table>
      </div>
    )
  }

  private renderDay = (cell: EasterEggCell) => {
    const className = classNames(
      cell.disabled ? 'non-month-day' : 'month-day',
      cell.disabled === false && 'is-selectable',
      cell.selected && 'full-selected',
    )
    return (
      <td className={className} onClick={() => this.selectDay(cell)}>
        <div />
      </td>
    )
  }

  private selectDay = (cell: EasterEggCell) => {
    const cells = [...this.state.cells]
    const index = cells.indexOf(cell)
    cells[index] = { ...cell, selected: !cell.selected }
    this.setState({ cells })
    if (
      cells.filter(x => !x.disabled && !x.selected).length === 0 &&
      this.props.onComplete
    ) {
      this.props.onComplete()
    }
  }

  private renderWeeks = () => {
    const rows: JSX.Element[] = []
    let cells: JSX.Element[] = []
    this.state.cells.forEach((cell, index) => {
      if (cells.length === 7) {
        rows.push(<tr key={index}>{cells}</tr>)
        cells = []
      }

      cells.push(this.renderDay(cell))
    })
    rows.push(<tr key={0}>{cells}</tr>)
    return rows
  }
}

export default EasterEggCalendarMonth
